import { render, staticRenderFns } from "./proposal-card-title.vue?vue&type=template&id=926728b4&scoped=true&"
import script from "./proposal-card-title.vue?vue&type=script&lang=js&"
export * from "./proposal-card-title.vue?vue&type=script&lang=js&"
import style0 from "./proposal-card-title.vue?vue&type=style&index=0&id=926728b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "926728b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev2/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('926728b4')) {
      api.createRecord('926728b4', component.options)
    } else {
      api.reload('926728b4', component.options)
    }
    module.hot.accept("./proposal-card-title.vue?vue&type=template&id=926728b4&scoped=true&", function () {
      api.rerender('926728b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/fl223/partials/proposal-card-title.vue"
export default component.exports